import styles from "./cardChatIA.module.scss";
import { addPointsInText } from "../../helpers/app";
import { Link } from 'react-router-dom';
import { images } from "../../constants/images";

interface CardChatIAProps {
    item: any;
    className?: string;
    navigation?: string;
    loading?: boolean;
    onClickCard?: () => void;
    disabled?: boolean;
}

const CardChatIA = ({
    item,
    className = '',
    navigation = '',
    loading = false,
    onClickCard = () => { },
    disabled = false,
}: CardChatIAProps) => {

    const truncateText = (text: string, maxLength: number) => {
        if (!text) return '';
        return text.length > maxLength ? `${text.substring(0, maxLength)}...` : text;
    }

    const handleClick = (e: React.MouseEvent) => {
        if (disabled) {
            e.preventDefault();
            return;
        }
        onClickCard();
    };

    return (
        <Link onClick={handleClick} to={navigation} className={`${styles.card} ${disabled ? styles.disabled : ''} ${className}`}>
            <div className={styles.imageContainer}>
                <img
                    loading="lazy"
                    src={(item?.pictures?.original?.[0]?.path || item?.pictures?.[0]?.path) ?? images.noImagePublication}
                    className={styles.imageCard}
                    alt={`${item?.title} ${item?.vehicle_data?.version ?? ""} año ${item?.primary_description}`}
                    title={`${item?.title} ${item?.vehicle_data?.version ?? ""} año ${item?.primary_description}`}
                />
            </div>

            <div className={styles.content}>
                <h2 className={styles.title}>{truncateText(item?.title, 24)}</h2>
                
                <div className={styles.detailsContainer}>
                    <div className={styles.detailItem}>
                        <span className={styles.detailLabel}>AÑO</span>
                        <span className={styles.detailValue}>{item?.primary_description || item?.year}</span>
                    </div>

                    <div className={styles.detailItemBorder}>
                        <span className={styles.detailLabel}>KM</span>
                        <span className={styles.detailValue}>{addPointsInText(item?.secondary_description)}</span>
                    </div>

                    <div className={styles.detailItem}>
                        <span className={styles.detailLabel}>PRECIO</span>
                        <span className={styles.detailPrice}>${addPointsInText(item?.price)}</span>
                    </div>
                </div>
            </div>
        </Link>
    );
}

export default CardChatIA;
